import { Component, Input, ChangeDetectionStrategy, Inject, PLATFORM_ID } from '@angular/core';
import { PreferencesCookieService } from '@app/core/cookies';
import { isPlatformBrowser } from '@angular/common';
import { LocaleService } from '@app/core/i18n';
import { UserService } from '@app/core/user/services/user/user.service';
import { take } from 'rxjs/operators';
@Component({
  selector: 'vc-footer-copyright',
  templateUrl: './footer-copyright.component.html',
  styleUrls: ['./footer-copyright.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterCopyrightComponent {
  @Input()
  domainsLinks: any;
  @Input()
  home: boolean;
  @Input()
  pagetype: string;

  public companyName = 'Vestiaire Collective';
  public currentYear = new Date().getFullYear();

  constructor(
    private preferencesCookieService: PreferencesCookieService,
    private userService: UserService,
    private localeService: LocaleService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  setLanguage(event: MouseEvent, mnemonic: string, url: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const { regionId, languageCode, currencyCode } = this.preferencesCookieService.getCkCookie();
    let newLanguageCode = languageCode;

    switch (mnemonic) {
      case 'en_uk':
        newLanguageCode = 'en';
        break;

      case 'en_us':
        newLanguageCode = 'us';
        break;

      default:
        newLanguageCode = mnemonic;
    }

    if (newLanguageCode !== languageCode) {
      this.preferencesCookieService.setCkCookie(regionId, newLanguageCode, currencyCode);
      event.preventDefault();
      this.setPreferencesCookies(newLanguageCode, url);
    }
  }
  setPreferencesCookies(language, url): void {
    const userI18n = {
      country: this.localeService.getLocale().getRegion(),
      language: language,
      currency: this.localeService.getCurrency()
    };

    this.userService
      .updateUserSettings(userI18n)
      .pipe(take(2))
      .subscribe(
        () => {
          document.location.replace(url);
        },
        () => {
          // Silently catch exception
        }
      );
  }
  get isSsrLinkFooterOpened() {
    return this.pagetype !== 'homepage' && this.pagetype !== 'catalog';
  }
}
